import React from 'react';

import CtaWithHint from 'components/CtaWithHint';
import LegalPageLayout from 'components/LegalPageLayout';
import LocalizedLink from 'components/LocalizedLink';
import TrustProof from 'components/TrustProof';
import { GUIDE_SLUGS } from 'content/marketingRoutes';
import { useI18n } from 'i18n/I18nContext';
import trackEvent from 'utils/trackEvent';

const GuidesIndexPage = () => {
  const { t, locale } = useI18n();

  return (
    <LegalPageLayout
      title={t('guides.indexTitle')}
      lede={t('guides.indexIntro')}
      variant="marketing"
      wide
    >
      <div className="gb-venue-layout">
        <div className="gb-venue-layout__list">
          <p className="gb-venue-layout__eyebrow m-0">{t('guides.pickLabel')}</p>
          <ol className="gb-venue-list">
            {GUIDE_SLUGS.map((slug, index) => {
              const n = String(index + 1).padStart(2, '0');
              return (
                <li key={slug}>
                  <LocalizedLink
                    className="gb-venue-row"
                    to={`/guides/${slug}`}
                    onClick={() =>
                      trackEvent('guide_select', { slug, locale, position: index + 1 })
                    }
                  >
                    <span className="gb-venue-row__index" aria-hidden>
                      {n}
                    </span>
                    <span className="gb-venue-row__copy">
                      <span className="gb-venue-row__label">{t(`guides.${slug}.title`)}</span>
                      <span className="gb-venue-row__meta">
                        {t('guides.readTime', { minutes: t(`guides.${slug}.minutes`) })}
                      </span>
                      <span className="gb-venue-row__body">{t(`guides.${slug}.intro`)}</span>
                    </span>
                    <span className="gb-venue-row__go" aria-hidden>
                      →
                    </span>
                  </LocalizedLink>
                </li>
              );
            })}
          </ol>
        </div>

        <aside className="gb-venue-layout__aside">
          <div className="gb-venue-aside">
            <CtaWithHint
              href="/onboard"
              buttonLabel={t('guides.cta')}
              hint={t('guides.ctaHint')}
              trackProps={{ source: 'guides_index' }}
            />
            <TrustProof className="mt-25" />
            <p className="mt-35 mb-0">
              <LocalizedLink className="gb-venue-aside__link" to="/for">
                {t('guides.seeVerticals')}
              </LocalizedLink>
            </p>
          </div>
        </aside>
      </div>
    </LegalPageLayout>
  );
};

export default GuidesIndexPage;



// WEBPACK FOOTER //
// ./src/pages/GuidesIndexPage.tsx